import { i18n } from "@lingui/core";
import { useToasters } from "@mobsuccess-devops/react-ui/Toaster/use-toasters";
import { useMutation } from "@tanstack/react-query";

import { fetchAuthSession } from "aws-amplify/auth";

import { axiosPost } from "../fetch/query";
import { clearStoredBundles } from "../i18n/i18n";

import { AuthActionEnum } from "./auth-context";
import { signOut } from "./cognito-storage";
import { setPatAuthorization } from "./session";

export async function signOutHandler(): Promise<void> {
  // oxlint-disable-next-line mobsuccess/member-expressions
  const session = await fetchAuthSession().catch(() => null);
  if (session?.tokens) {
    window._msAuthBroadcastChannel?.postMessage("signout");
  }
  await axiosPost({
    entity: "auth",
    verb: "signout",
    token: null,
  });
  await signOut();
  // Drop any stored PAT so a PHP-side or URL-driven sign-out (which goes
  // through this handler directly, not `useSignout`) doesn't leave the user
  // auto-re-authenticated on the next /auth load.
  setPatAuthorization(null);
  clearStoredBundles();
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useSignout({
  postSignout,
}: {
  postSignout?: (_?: { redirect?: string }) => Promise<void> | void;
} = {}) {
  const { toast } = useToasters();
  return useMutation({
    mutationKey: [AuthActionEnum.SignOut],
    async mutationFn(options?: { redirect?: string }) {
      try {
        await signOutHandler();
      } finally {
        if (postSignout) {
          await postSignout(options);
        }
      }
    },
    onError() {
      toast.error({
        title: i18n._("src.public.auth.sign-out-error.title"),
        description: i18n._("src.public.auth.sign-out-error.description"),
      });
    },
  });
}
